// @vendors
import React from 'react';

// @components
import { CallMeBack } from 'components/callMeBack/callMeBack';
import AggregatorInfo from './../aggregatorInfo/AggregatorInfo';

// @utilities
const { formatText } = require('core/i18n').i18n;

function InfoColumn() {
    return (
        <div className="col-xs-12 col-md-4">
            <div className="row">
                <div className="col-xs-12 col-sm-6 col-md-12 grid-view--variable-cell-separation">
                    <AggregatorInfo />
                </div>
                <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                    <CallMeBack pageTitle={formatText('breadcrumb-global')} />
                </div>
            </div>
        </div>
    )
}

export default InfoColumn;
